<div
  class="w-fill-available flex flex-col gap-2"
  [attr.aria-disabled]="disabled()"
  [class.opacity-60]="disabled()"
  [class.pointer-events-none]="disabled()"
>
  <h3 class="text-base">{{ 'pages.campaignDetails.filter.scope' | translate }}</h3>

  <!--
    Mobile briefing: the date select keeps its label's width and the platform select takes the rest. Both use the
    mock's tighter padding and 13px text so "Full campaign duration" and "All platforms (n)" fit side by side.
  -->
  <div class="flex items-center gap-4 w-fill-available" [ngClass]="{ 'max-md:gap-2': creatorBriefingMode() }">
    @if (dateFilterReady()) {
      <app-profile-date-filter
        class="w-[252px]"
        [ngClass]="{
          'max-md:w-auto max-md:min-w-0 max-md:[&_.campaign-details-date-filter-trigger]:!pl-4 max-md:[&_.campaign-details-date-filter-trigger]:!pr-3 max-md:[&_.campaign-details-date-filter-trigger_span]:!text-[13px]':
            creatorBriefingMode(),
        }"
        [campaignAnalytics]="campaignAnalytics()"
        [initialState]="dateFilterState()"
        [loading]="loading()"
        [allowedDateRange]="allowedDateRange()"
        (dateRangeChanged)="onDateRangeChanged($event)"
        (selectedRangeChanged)="onSelectedRangeChanged($event)"
      />
    } @else {
      <ngx-skeleton-loader
        class="w-[252px] h-[34px]"
        [ngClass]="{ 'max-md:w-auto max-md:flex-1 max-md:min-w-0': creatorBriefingMode() }"
        [theme]="{ height: '34px', width: '100%', 'border-radius': '100vw' }"
      />
    }

    <app-profile-platform-feature-select
      class="w-[252px]"
      [ngClass]="{
        'max-md:w-auto max-md:flex-1 max-md:min-w-[120px] max-md:[&_.mat-mdc-text-field-wrapper]:!pl-4 max-md:[&_.mat-mdc-text-field-wrapper]:!pr-3 max-md:[&_.mat-mdc-select-min-line]:!text-[13px]':
          creatorBriefingMode(),
      }"
      [campaignAnalytics]="campaignAnalytics()"
      [initialSelectedPlatformFeatures]="campaignAnalyticsFilter().platformFeatures"
      [loading]="loading()"
      [panelWidth]="platformPanelWidth()"
      (panelClosed)="onPlatformFeaturesPanelClosed()"
      (platformFeaturesChanged)="onPlatformFeaturesChanged($event)"
    />

    @if (!creatorBriefingMode()) {
      <app-profile-general-filters
        class="w-[252px]"
        [campaignAnalytics]="campaignAnalytics()"
        [initialSelectedCreatorIds]="campaignAnalyticsFilter().creatorIds"
        [loading]="loading()"
        (panelClosed)="onCreatorIdsPanelClosed()"
        (creatorIdsChanged)="onCreatorIdsChanged($event)"
      />
    }
  </div>
</div>
